import { type FC, useMemo } from "react";

import { Loading, TopBar, VerificationStepper } from "src/components";
import { Routes } from "src/routes";
import { UserVerificationTypeEnum } from "src/types";
import { Aml, Kyc } from "./components";
import { BankId } from "./components/BankId";
import { SumSub } from "./components/SumSub";
import { VerificationSubTypeEnum } from "./enums";
import { useVerificationRedirect } from "./utils";

export const VerificationPage: FC = () => {
    const { verificationType, verificationSubType } = Routes.verifications.useParams();

    useVerificationRedirect();

    const VerificationComponent = useMemo(() => {
        if (verificationType === UserVerificationTypeEnum.KYC) {
            if (!verificationSubType) {
                return <Kyc />;
            }
            if (verificationSubType === VerificationSubTypeEnum.BANKID) {
                return <BankId />;
            }
            if (verificationSubType === VerificationSubTypeEnum.SUMSUB) {
                return <SumSub />;
            }
        }
        if (verificationType === UserVerificationTypeEnum.AML) {
            return <Aml />;
        }
        return <Loading />;
    }, [verificationType, verificationSubType]);

    return (
        <div className="min-h-screen">
            <div className="sticky top-0 bg-brand-white">
                <VerificationStepper activeVerificationType={verificationType as UserVerificationTypeEnum} />
                <TopBar />
            </div>
            {VerificationComponent}
        </div>
    );
};
